/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  BOOKINGS_COMPLETED,
  BOOKING_BY_ID,
  BOOKING_INVOICE,
  BOOKING_MULTI_INVOICE,
} from "../../constants/api";
import { INFO_MSG_TYPE } from "../../constants/messages";

import {
  Layout,
  Row,
  Col,
  Card,
  Button,
  Space,
  Drawer,
  DatePicker,
  Select,
  Typography,
  Tag,
  Empty,
  Spin,
  Divider,
} from "antd";

import {
  UserOutlined,
  HomeOutlined,
  DollarOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";
import BookingPopOver from "./BookingPopOver";
import {
  BUSINESS_SEGMENT_IMG,
  capitalizeWords,
  getBookingType,
} from "../../constants/constent";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

function BookingInvoice() {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  // Booking Detail Model
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isBookingPopOverShow, setIsBookingPopOverShow] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [invoiceUrl, setInvoiceUrl] = useState("");

  const [filters, setFilters] = useState({
    filterType: "Check In",
    startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);

    let url = BOOKINGS_COMPLETED;

    if (filters.startDate && filters.endDate) {
      url += `?filterType=${filters.filterType}&startDate=${filters.startDate}&endDate=${filters.endDate}`;
    }

    getAPI(
      url,
      (data) => {
        if (data.status) {
          setState(data.data);
        } else {
          displayMessage(INFO_MSG_TYPE, data.message);
          setState([]);
        }
        setLoading(false);
      },
      () => {
        setState([]);
        setLoading(false);
      },
    );
  };

  const handleClose = () => {
    setIsBookingPopOverShow(false);
    setSelectedBooking(null);
  };

  const getBookingDetail = (id) => {
    const successFn = function (data) {
      if (data.status === true) {
        setSelectedBooking(data.data);
        setIsBookingPopOverShow(true);
        setLoading(false);
      } else {
        setIsBookingPopOverShow(false);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setIsBookingPopOverShow(false);
      setLoading(false);
    };
    postAPI(BOOKING_BY_ID, { id: id }, successFn, errorFn);
  };
  const openInvoice = (url) => {
    setInvoiceUrl(url);
    setDrawerOpen(true);
  };

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card>
          {/* PAGE HEADER */}
          <div style={{ marginBottom: 16 }}>
            <Typography.Title level={3} style={{ marginBottom: 0 }}>
              Booking Invoices
            </Typography.Title>
            <Typography.Text type="secondary">
              View and download booking invoices by date range
            </Typography.Text>
          </div>

          {/* FILTERS */}
          <div
            style={{
              backgroundColor: "lightgray",
              padding: "10px",
              marginBottom: 20,
              borderRadius: 12,
            }}
          >
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24} md={6}>
                <Select
                  value={filters.filterType}
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, filterType: value }))
                  }
                  style={{ width: "100%" }}
                  size="large"
                >
                  <Option value="Booking Date">Booking Date</Option>
                  <Option value="Check In">Check In</Option>
                  <Option value="Check Out">Check Out</Option>
                  <Option value="Stay Date">Stay Date</Option>
                </Select>
              </Col>

              <Col xs={24} md={10}>
                <RangePicker
                  size="large"
                  style={{ width: "100%" }}
                  value={[dayjs(filters.startDate), dayjs(filters.endDate)]}
                  onChange={(dates, dateStrings) =>
                    setFilters((prev) => ({
                      ...prev,
                      startDate: dateStrings[0],
                      endDate: dateStrings[1],
                    }))
                  }
                />
              </Col>

              <Col xs={24} md={8} style={{ textAlign: "right" }}>
                <Space>
                  <Button type="primary" size="large" onClick={getData}>
                    Apply
                  </Button>

                  <Button
                    size="large"
                    onClick={() => {
                      setFilters({
                        filterType: "Check In",
                        startDate: dayjs()
                          .startOf("month")
                          .format("YYYY-MM-DD"),
                        endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
                      });
                      setTimeout(getData, 0);
                    }}
                  >
                    This Month
                  </Button>
                </Space>
              </Col>
            </Row>
          </div>

          {/* BOOKINGS */}
          {loading ? (
            <Spin size="large" />
          ) : state.length === 0 ? (
            <Empty description="No bookings found" />
          ) : (
            <>
              <Divider />
              <Row gutter={[16, 16]}>
                {state.map((row) => (
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={6}
                    key={row.id}
                    style={{
                      borderRadius: 14,
                      boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                    }}
                  >
                    {/* Container */}
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: 14,
                      }}
                    >
                      {/* Watermark Layer */}
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          backgroundImage: `url(${
                            BUSINESS_SEGMENT_IMG[getBookingType(row)] ||
                            BUSINESS_SEGMENT_IMG.others
                          })`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "180px",
                          opacity: 0.06,
                          zIndex: 0,
                          pointerEvents: "none",
                        }}
                      />

                      {/* Card Content */}
                      <Card
                        hoverable
                        style={{
                          position: "relative",
                          zIndex: 1,
                          background: "transparent",
                        }}
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>#{row.invoice_id}</span>

                            <div>
                              <Tag
                                color={
                                  row.payment_status === "1"
                                    ? "green"
                                    : "orange"
                                }
                              >
                                {row.payment_method}
                              </Tag>

                              <img
                                style={{ width: "25px", marginLeft: 8 }}
                                src={
                                  BUSINESS_SEGMENT_IMG[getBookingType(row)] ||
                                  BUSINESS_SEGMENT_IMG.others
                                }
                                alt={getBookingType(row)}
                                title={getBookingType(row)}
                              />
                            </div>
                          </div>
                        }
                      >
                        <p>
                          <UserOutlined /> <b>Customer:</b>{" "}
                          {capitalizeWords(row.customer_name)}
                        </p>

                        <p>
                          <HomeOutlined /> <b>Room:</b>{" "}
                          {row.room_category_title} {row.room_no}
                        </p>

                        <p
                          style={{
                            fontSize: 16,
                            fontWeight: 600,
                            color: "#1677ff",
                          }}
                        >
                          <DollarOutlined /> ₹
                          {parseFloat(row.total_with_gst || 0) +
                            parseFloat(row.order_amount || 0) +
                            parseFloat(row.ex_service_amount || 0)}
                        </p>

                        <Divider style={{ margin: "10px 0" }} />

                        <Row gutter={[16, 16]}>
                          <Col xs={12}>
                            {row.booking_status === "2" &&
                              row.payment_status === "1" && (
                                <Button
                                  block
                                  onClick={() => {
                                    const encodedId = btoa(row.id.toString());
                                    openInvoice(
                                      `${BOOKING_INVOICE}${encodedId}`,
                                    );
                                  }}
                                >
                                  View Invoice
                                </Button>
                              )}
                          </Col>

                          <Col xs={12}>
                            {row.booking_status === "2" &&
                              row.payment_status === "1" &&
                              row.multi_book_id && (
                                <Button
                                  block
                                  onClick={() => {
                                    const encodedId = btoa(
                                      row.multi_book_id.toString(),
                                    );
                                    openInvoice(
                                      `${BOOKING_MULTI_INVOICE}${encodedId}`,
                                    );
                                  }}
                                >
                                  View Multi Invoice
                                </Button>
                              )}
                          </Col>
                        </Row>

                        <Divider style={{ margin: "10px 0" }} />

                        <Button
                          block
                          onClick={() => {
                            getBookingDetail(row.id);
                          }}
                        >
                          View Details
                        </Button>
                      </Card>
                    </div>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Card>
        {/* DRAWER */}
        <Drawer
          title="Invoice Preview"
          placement="right"
          width="70%"
          onClose={() => {
            setInvoiceUrl("");
            setDrawerOpen(false);
          }}
          open={drawerOpen}
        >
          {invoiceUrl ? (
            <iframe
              src={invoiceUrl}
              title="Invoice"
              style={{
                width: "100%",
                height: "85vh",
                border: "none",
                borderRadius: 8,
              }}
            />
          ) : (
            <Empty description="No Invoice Found" />
          )}
        </Drawer>
        {/* Detail Modal */}
        {isBookingPopOverShow && selectedBooking && (
          <BookingPopOver
            visible={isBookingPopOverShow}
            onClose={handleClose}
            booking={selectedBooking} // Pass the booking data here
          />
        )}
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default BookingInvoice;
